/**
 * 全局配置文件
 */
let javaURL = 'https://www.sunflower-soft.com/sun_flower_soft/';
// let javaURL = 'http://127.0.0.1:8080/sun_flower_soft/';
export default { javaURL }